import React, { useState, useCallback } from "react";
import { NavLink } from "react-router-dom";
import { Collapse, Link, Button, Grid, ClickAwayListener } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ExpandLess } from "@mui/icons-material";
import PropTypes from "prop-types";
import clsx from "clsx";

import MegaMenuItemPresenter from "presenters/MegaMenuItemPresenter";

import SubNavigation from "../SubNavigation";

import useStyles from "./useStyles";

const MenuItem = ({ menuItem, mainMenuLinks, onClick }) => {
  const classes = useStyles();
  const [collapseSubMenu, setCollapseSubMenu] = useState(false);
  const [hasActiveSubLink, setHasActiveSubLink] = useState(false);
  const name = MegaMenuItemPresenter.name(menuItem);
  const subMenu = MegaMenuItemPresenter.childrenMenu(menuItem);

  const handleClickSubMenu = useCallback((value) => {
    setCollapseSubMenu(value);
  }, []);

  const handleSubLinkActiveChange = useCallback((isActive) => {
    setHasActiveSubLink(isActive);
  }, []);

  const renderSimpleLink = () => {
    return MegaMenuItemPresenter.isExternalLinkTo(menuItem) ? (
      <Link
        id={MegaMenuItemPresenter.createComponentId(menuItem)}
        className={classes.link}
        href={MegaMenuItemPresenter.linkTo(menuItem)}
        onClick={onClick}
      >
        {name}
      </Link>
    ) : (
      <Link
        id={MegaMenuItemPresenter.createComponentId(menuItem)}
        exact
        activeClassName={classes.activelink}
        className={classes.link}
        to={MegaMenuItemPresenter.linkTo(menuItem)}
        component={NavLink}
        onClick={onClick}
      >
        {name}
      </Link>
    );
  };

  const renderCollapsableLink = () => {
    return (
      <ClickAwayListener onClickAway={() => handleClickSubMenu(false)}>
        <Grid
          className={clsx(classes.link, { [classes.activelink]: hasActiveSubLink })}
          onClick={() => handleClickSubMenu(!collapseSubMenu)}
        >
          <Button
            id={`button-${MegaMenuItemPresenter.createComponentId(menuItem)}`}
            variant="link"
            endIcon={collapseSubMenu ? <ExpandLess /> : <ExpandMoreIcon />}
          >
            {name}
          </Button>
          <Collapse in={collapseSubMenu} className={classes.subMenu}>
            <SubNavigation
              menuItem={menuItem}
              mainMenuLinks={mainMenuLinks}
              onLinkActiveChange={handleSubLinkActiveChange}
            />
          </Collapse>
        </Grid>
      </ClickAwayListener>
    );
  };

  return subMenu && subMenu.length === 0 ? renderSimpleLink() : renderCollapsableLink();
};

MenuItem.propTypes = {
  menuItem: MegaMenuItemPresenter.shape(),
  mainMenuLinks: PropTypes.arrayOf(PropTypes.string),
  onClick: PropTypes.func,
};

export default MenuItem;
